var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 529,
    viewBox: "0 0 651 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.527 121.399L223.802 142.57L137.113 92.278L175.168 71.1064L260.527 121.399Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.527 233.225L223.802 254.402L137.113 204.11L175.168 182.938L260.527 233.225Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.314 233.225L223.589 254.402L136.906 204.11L174.955 182.938L260.314 233.225Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.801 142.57V254.402",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.496 71.1064V182.939L137.152 204.077V92.2446",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.527 121.026V232.858",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.768 390.26L452.052 457.552L176.566 297.731L297.488 230.434L568.768 390.26Z",
    fill: "#C1282D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.417 162.719L150.693 183.89L64.0039 133.604L102.053 112.427L187.417 162.719Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.417 274.551L150.693 295.723L64.0039 245.43L102.053 224.259L187.417 274.551Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.205 274.551L150.48 295.723L63.7969 245.43L101.846 224.259L187.205 274.551Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.691 183.891V295.723",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.386 112.427V224.259L64.043 245.397V133.565",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.418 162.352V274.184",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M494.683 177.309L457.958 198.486L371.27 148.194L409.318 127.022L494.683 177.309Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M494.683 289.141L457.958 310.318L371.27 260.026L409.318 238.854L494.683 289.141Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M494.47 289.141L457.746 310.318L371.062 260.026L409.111 238.854L494.47 289.141Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M457.957 198.486V310.318",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.652 127.022V238.855L371.309 259.993V148.161",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M494.684 176.942V288.774",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.488 240.406L571.763 261.584L485.074 211.291L523.123 190.114L608.488 240.406Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.488 352.238L571.763 373.416L485.074 323.123L523.123 301.946L608.488 352.238Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.275 352.238L571.55 373.416L484.867 323.123L522.916 301.946L608.275 352.238Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.762 261.583V373.415",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.457 190.114V301.946L485.113 323.084V211.252",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.488 240.039V351.871",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.387 101.679L327.111 122.85L413.8 72.5638L375.752 51.3867L290.387 101.679Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M290.387 213.511L327.111 234.682L413.8 184.396L375.752 163.219L290.387 213.511Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.598 213.511L327.322 234.682L414.006 184.396L375.957 163.219L290.598 213.511Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M327.109 122.851V234.683",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M375.418 51.3867V163.219L413.761 184.357V72.5249",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M290.387 101.312V213.144",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.562 51.2922L246.287 72.4637L332.97 22.1771L294.922 1L209.562 51.2922Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.562 163.124L246.287 184.296L332.97 134.004L294.922 112.832L209.562 163.124Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.77 163.124L246.494 184.296L333.183 134.004L295.134 112.832L209.77 163.124Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.594 1V112.832L332.937 133.97V22.1382",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.562 162.751V50.9248L246.287 72.4635V184.296",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.902 394.787L332.627 415.959L419.31 365.672L381.262 344.495L295.902 394.787Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.902 506.619L332.627 527.791L419.31 477.499L381.262 456.327L295.902 506.619Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.113 506.619L332.838 527.791L419.521 477.499L381.473 456.327L296.113 506.619Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.625 415.959V527.791",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.934 344.495V456.327L419.277 477.465V365.633",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.902 394.42V506.246",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.797 344.629L260.522 365.806L347.205 315.514L309.156 294.343L223.797 344.629Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M223.797 456.461L260.522 477.638L347.205 427.346L309.156 406.169L223.797 456.461Z",
    stroke: "#231F20",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.004 456.461L260.734 477.638L347.417 427.346L309.369 406.169L224.004 456.461Z",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.52 365.807V477.639",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.828 294.343V406.169L347.172 427.307V315.481",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M223.797 344.263V456.095",
    stroke: "white",
    strokeWidth: 1.70218,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8555 297.68V390.543",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6523 289.062V391.805",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.059 305.835V369.06",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.457 310.908V362.285",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2266 305.857V378.962",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8516 307.531V400.4",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2227 315.714V388.819",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 314.035V356.517",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6211 318.679V381.904",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0234 322.056V373.427",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4219 322.629V365.111",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116.664 324.215V339.034",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 310.084V346.714",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M123.461 307.119V343.749",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M113.23 322.518V343.261",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.867 306.708V343.338",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.672 301.251V342.788",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M137.066 291.339V345.675",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.469 286.699V350.915",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.234 313.484V334.233",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M143.871 293.775V350.086",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M150.676 284.725V340.045",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 275.279V344.434",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M157.473 287.267V328.803",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M147.242 303.532V327.057",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.875 285.608V327.145",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M167.68 281.131V322.662",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M171.078 291.061V311.809",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.477 279.468V321.004",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M164.246 293.18V316.704",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.73 276.998V318.535",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M185.535 272.52V314.05",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M188.934 269.968V311.504",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M192.332 275.379V304.644",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M182.105 283.718V307.242",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.738 273.8V303.065",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M202.543 269.789V299.054",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M205.941 270.641V291.801",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M209.336 263.285V296.689",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M199.109 277.682V294.258",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M212.746 264.204V293.469",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M219.547 260.199V289.464",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M222.941 261.3V278.956",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.344 254.258V279.346",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M216.113 268.092V284.669",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M229.746 257.596V277.226",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M236.551 254.285V278.85",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M239.949 254.063V267.97",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M243.348 250.074V266.629",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M233.117 260.911V274.823",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M246.754 248.74V265.289",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M253.555 243.411V268.093",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M256.957 243.411V268.093",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M260.359 239.522V255.532",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M250.121 250.068V264.042",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M263.758 235.874V259.638",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M267.156 232.47V256.233",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M270.562 232.246V256.01",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M273.961 234.088V250.882",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M280.762 232.964V243.828",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M284.164 224.781V248.495",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M287.566 216.742V253.372",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M290.938 223.547V242.249",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M294.371 213.338V249.968",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M277.332 230.549V251.292",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M565.848 344.096V432.898",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M559.047 334.077V432.331",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M555.648 353.257V413.718",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M552.242 356.378V405.502",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M562.48 351.839V421.751",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M582.855 354.958V443.761",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M579.484 360.154V430.066",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M548.848 358.736V399.361",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M576.078 364.688V425.148",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M572.684 367.809V416.933",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M569.281 370.168V410.792",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M542.043 366.958V381.126",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M538.641 355.81V390.838",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M535.238 353.824V388.852",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M545.477 366.958V386.794",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M531.84 351.839V386.867",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M525.035 345.92V385.637",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M521.637 335.59V387.551",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M518.23 329.638V391.044",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M528.473 356.656V376.498",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M514.836 331.529V385.376",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M508.031 327.752V380.653",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M504.633 318.018V384.152",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M501.23 331.773V371.491",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M511.465 344.852V367.347",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M497.832 329.409V369.127",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M491.027 325.126V364.843",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M487.629 336.252V356.094",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M484.227 321.911V361.629",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M494.457 335.84V358.335",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M479.973 315.486V355.204",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M473.172 311.197V350.92",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M469.77 311.197V350.92",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M466.367 313.934V341.919",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M476.602 321.911V344.407",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M367.738 243.099V296.951",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M360.938 238.471V291.377",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M357.539 231.29V297.425",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M354.133 243.344V283.067",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M364.363 258.124V280.619",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M350.734 240.985V280.703",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M343.934 235.845V275.568",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M340.527 244.423V264.265",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M337.129 232.636V272.353",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M347.359 246.56V269.055",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M332.883 231.307V271.024",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M326.082 224.47V264.193",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M322.676 224.47V264.193",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M319.273 227.207V255.193",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M329.504 236.885V259.38",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M462.969 312.427V340.413",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M456.164 309.406V337.392",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M452.766 309.406V329.638",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M449.363 303.187V335.127",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M459.598 316.955V332.803",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M445.961 304.878V332.864",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M439.16 301.857V329.843",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M435.762 300.473V317.355",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M432.355 293.736V317.728",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M442.59 309.406V325.254",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M428.957 296.929V315.703",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M422.156 293.764V317.255",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M418.758 293.553V306.848",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M415.355 289.736V305.568",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M425.586 300.1V313.406",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M411.953 288.457V304.288",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M405.152 283.368V306.965",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M401.75 278.267V301.863",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M398.348 280.497V295.806",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M408.582 289.73V303.098",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M394.945 274.605V297.329",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M391.543 272.903V295.627",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M388.145 271.062V293.792",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M384.746 272.009V288.068",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M377.945 270.969V281.365",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M374.539 261.522V284.196",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M371.141 253.868V288.896",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M381.371 268.515V288.351",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2266 109.606L649.752 437.943",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4.22 4.22"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M298.592 229.638L1 395.1",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4.22 4.22"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M632.746 86.7939L335.148 252.256",
    stroke: "#C1282D",
    strokeWidth: 1.27385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4.22 4.22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.8271e3d88fcc4bf76fd829b04513096f.svg";
export { ForwardRef as ReactComponent };